import DeclinedRequestsTable from './DeclinedRequestsTable'

export default DeclinedRequestsTable
